export default __webpack_public_path__ + "static/media/banner.b6220be1.png";